import React, { Component } from "react";

import { TextField, StyledButton, Loadable } from "components/support";

import Popover from "material-ui-next/Popover";
import Icon from "material-ui-next/Icon";

class ReportEmail extends Component {
  state = {
    email: "",
    anchorEl: {},
    visible: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.presenter.onSend(this.state.email);
  };

  handleInputChange = (_, value) => {
    this.setState({ email: value });
  };

  handleButtonClick = e => {
    e.preventDefault();

    this.setState({
      anchorEl: e.currentTarget,
      visible: true
    });
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  render() {
    const { loading } = this.props;
    const { email, anchorEl, visible } = this.state;

    return (
      <div className="report-email">
        <StyledButton
          label="Via E-mail"
          leftIcon={<Icon>email</Icon>}
          accent
          onTouchTap={this.handleButtonClick}
        />
        <Popover
          open={visible}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          onClose={this.handleClose}
        >
          <Loadable loading={loading}>
            <form
              onSubmit={this.handleSubmit}
              style={{ padding: "0px 8px 12px" }}
            >
              <TextField
                fullWidth
                value={email}
                onChange={this.handleInputChange}
                label="Seu e-mail"
              />
              <StyledButton
                type="submit"
                primary
                label="Enviar"
                style={{ marginLeft: 0, marginTop: 8 }}
              />
              <StyledButton
                type="button"
                onTouchTap={this.handleClose}
                flat
                label="Cancelar"
              />
            </form>
          </Loadable>
        </Popover>
      </div>
    );
  }
}

export default ReportEmail;



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/report-email/view.jsx